import { render } from "./service_index.vue?vue&type=template&id=6fb70c94&scoped=true"
import script from "./service_index.vue?vue&type=script&lang=js"
export * from "./service_index.vue?vue&type=script&lang=js"

import "./service_index.vue?vue&type=style&index=0&id=6fb70c94&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb70c94"]])

export default __exports__